import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


export class XwaysHoarder2ScreenView extends PIXI.Container implements StageLayer {

    protected button: ContinueButton;
    private clickCallback?: Function;


    constructor(name?: string) {
        super();
        this.name = name ? name : "TransitionScreenBaseView";
        this.init();
    }

    onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            this.button.position.set(360, 580);
        } else {
            const centerBottom: number = (bounds.bottom - 610) * 0.5 + 565;
            this.button.position.set(360, centerBottom - 80);
        }
    }

    public enableButton(cb: Function): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.clickCallback = cb;
            this.onResize();
        },0);

        if (XwaysHoarder2.model.data.wasFeatureBuy && XwaysHoarder2.autoPlayPlugin.isAutoplayRound && !XwaysHoarder2.model.data.brokeTheBank) {
            tl.to(this, {duration: 1.5});
            tl.add(() => {
                this.onButtonClick();
            })
        } else {
            tl.add(() => {
                this.button.visible = true;
            }, 0)
            tl.to(this.button, {
                alpha: 1,
                duration: 0.2
            }, "<");
            tl.add(() => {
                this.button.enable(true)
            }, ">");
        }


        return tl;
    }

    protected init() {
        this.button = new ContinueButton();
        this.button.addClickCallback(() => this.onButtonClick());
        this.button.pivot.set(this.button.width * 0.5, 0);
        this.button.enable(false);
        this.button.alpha = 0;
        this.button.visible = false;

        this.addChild(this.button);

    }

    private onButtonClick() {
        this.button.enable(false);

        //debugger;


        if (this.clickCallback == undefined) {
            throw new Error("No button click callback");
        }
        if (this.button.visible) {
            if (XwaysHoarder2.model.data.nextMode === GameMode.FREESPIN || XwaysHoarder2.model.data.nextFSLevel === 4) {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.FS_CONTINUE_BUTTON);
            }
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.CONTINUE_BUTTON);
            if(XwaysHoarder2.model.data.brokeTheBank) {
                XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.CAP_LOOP);
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.BIGWIN_END);
                XwaysHoarder2Sound.fadeMusic(1, 100);
            }
        }
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.to(this.button, {duration: 0.3, alpha: 0});
        tl.add(() => {
            this.button.visible = false;
            this.clickCallback!();
            delete this.clickCallback;
        }, ">");

    }

}